import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import { parseString } from "xml2js";
import api from "../../../api";
import settings from "../../../settings";
import Address from "../../searchresults/Address";
import { getDate } from "../../common/DisplayDate";
import VehicleDetails from "./VehicleDetails";
import getPersonName from "../../common/Name";

class MotorVehicles extends Component {
  state = {
    activeIndex: 0,
    rows: [],
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadSection = (node, props) => {
    const records = _.get(
      node,
      "personReport.mvraddonplats[0].motorVehicleSearch2Response[0].records[0].record"
    );
    const rows = [];
    let vehCount = 0;
    if (records !== undefined) {
      // let prevVehRecId = "";
      const vehIds = [];
      _.forEach(records, (record, index) => {
        const innerRows = [];
        const curVehRecId = _.get(
          record,
          "vehicleInfo[0].vehicleRecordId[0]._"
        );
        // if (prevVehRecId !== curVehRecId) {
        if (!vehIds.includes(curVehRecId)) {
          vehIds.push(curVehRecId);
          // prevVehRecId = curVehRecId;
          const year = _.get(record, "vehicleInfo[0].yearMake[0]._", "");
          const make = _.get(record, "vehicleInfo[0].make[0]._", "");
          const model = _.get(record, "vehicleInfo[0].model[0]._", "");
          const color = _.get(record, "vehicleInfo[0].series[0]._", "");
          const vinNumber = _.get(record, "vehicleInfo[0].VIN[0]._", "");
          const plate = _.get(
            record,
            "registrants[0].registrant[0].registrationInfo[0].trueLicensePlate[0]._",
            ""
          );

          const fullName = this.fullName(record);
          const persDetails = this.persDetails(record);
          const expires = [];
          const expireNodes = _.get(
            record,
            "registrants[0].registrant[0].registrationInfo[0].latestExpirationDate"
          );
          if (expireNodes !== undefined) {
            _.forEach(expireNodes, (expNode) => {
              expires.push(getDate(expNode));
            });
          }
          innerRows.push(
            <Table.Row key={`veh_name_row_${index}`}>
              <Table.Cell width={2}>Name:</Table.Cell>
              <Table.Cell width={6}>
                {persDetails.firstName !== ""
                  ? getPersonName(
                      persDetails.firstName,
                      "",
                      persDetails.lastName,
                      props
                    )
                  : fullName}
              </Table.Cell>
              <Table.Cell width={2}>Year/Make:</Table.Cell>
              <Table.Cell
                width={6}
              >{`${year} ${make} ${model} ${color}`}</Table.Cell>
            </Table.Row>
          );
          innerRows.push(
            <Table.Row key={`veh_add_row_${index}`}>
              <Table.Cell width={2}>Address:</Table.Cell>
              <Table.Cell width={6}>
                <Address addressNode={persDetails.addressNode} {...props} />
              </Table.Cell>
              <Table.Cell width={2}>VIN: </Table.Cell>
              <Table.Cell width={6}>{vinNumber}</Table.Cell>
            </Table.Row>
          );
          if (plate !== "") {
            innerRows.push(
              <Table.Row key={`veh_plate_row_${index}`}>
                <Table.Cell>Plate:</Table.Cell>
                <Table.Cell>{plate}</Table.Cell>
                <Table.Cell>Expires:</Table.Cell>
                <Table.Cell>{expires}</Table.Cell>
              </Table.Row>
            );
          }
          innerRows.push(
            <Table.Row key={`veh_detail_row_${index}`}>
              <Table.Cell colSpan={4}>
                <VehicleDetails
                  record={record}
                  detailIndex={index}
                  {...props}
                />
              </Table.Cell>
            </Table.Row>
          );
          vehCount += 1;
          // prevVehRecId = curVehRecId;
          rows.push(
            <Table.Row key={`veh_info_row_${index}`}>
              <Table.Cell>
                <Table className="table-no-padding">
                  <Table.Body>{innerRows}</Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
        }
      });
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, vehCount);
  };

  loadData = (props) => {
    const sectionNode = _.get(
      props.reportData,
      "personReport.mvraddonplats[0]"
    );
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else {
      const actId = _.get(
        props.reportData,
        "personReport.log[0].actID[0]._",
        ""
      );
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "mvraddonplat";
      if (actId !== "") additionalData.parentResultID = actId;
      api.report
        .person(additionalData)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            this.loadSection(rslt, props);
          });
        })
        .catch((err) => console.log("motor vehicle res error - ", err));
    }
  };

  fullName = (record) => {
    let fullName = _.get(record, "matchedParty[0].originName[0]._");
    if (
      fullName === undefined &&
      _.get(
        record,
        "registrants[0].registrant[0].registrantInfo[0].name[0]"
      ) !== undefined
    ) {
      fullName = `${_.get(
        record,
        "registrants[0].registrant[0].registrantInfo[0].name[0].first[0]._",
        ""
      )} ${_.get(
        record,
        "registrants[0].registrant[0].registrantInfo[0].name[0].middle[0]._",
        ""
      )} ${_.get(
        record,
        "registrants[0].registrant[0].registrantInfo[0].name[0].last[0]._",
        ""
      )}`;
    }
    if (fullName === undefined) {
      fullName = `${_.get(
        record,
        "lessees[0].lessee[0].lesseeInfo[0].name[0].first[0]._",
        ""
      )} ${_.get(
        record,
        "lessees[0].lessee[0].lesseeInfo[0].name[0].middle[0]._",
        ""
      )} ${_.get(
        record,
        "lessees[0].lessee[0].lesseeInfo[0].name[0].last[0]._",
        ""
      )}`;
    }
    return fullName;
  };

  persDetails = (record) => {
    const persDetails = {
      firstName: "",
      lastName: "",
      street: "",
      city: "",
      state: "",
      zip: "",
      addressNode: undefined,
    };
    let node = _.get(record, "matchedParty[0]");
    if (node === undefined)
      node = _.get(record, "owners[0].owner[0].ownerInfo[0]");
    if (node === undefined)
      node = _.get(record, "lessees[0].lessee[0].lesseeInfo[0]");
    if (node === undefined)
      node = _.get(record, "registrants[0].registrant[0].registrantInfo[0]");
    if (node !== undefined) {
      persDetails.firstName = _.get(node, "name[0].first[0]._", "");
      persDetails.lastName = _.get(node, "name[0].last[0]._", "");
      persDetails.street = `${_.get(
        node,
        "address[0].streetNumber[0]._",
        ""
      )} ${_.get(node, "address[0].streetName[0]._", "")} ${_.get(
        node,
        "address[0].streetSuffix[0]._",
        ""
      )}`;
      persDetails.city = _.get(node, "address[0].city[0]._", "");
      persDetails.state = _.get(node, "address[0].state[0]._", "");
      persDetails.zip = _.get(node, "address[0].zip[0]._", "");
      persDetails.addressNode = _.get(node, "address[0]");
    }
    return persDetails;
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          className="report-section-header"
          key={`MotorVehicle_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Motor Vehicles
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`MotorVehicle_Body`}
          active={this.state.activeIndex === 0}
        >
          {this.state.rows.length < 1 ? (
            <span>No Records Found</span>
          ) : (
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.Cell colSpan={4}>
                    <span>
                      I agree that I, and the organization I represent if
                      applicable, will NOT use the information accessed through
                      this search in whole or in part for the purpose of serving
                      as a factor in establishing a consumer’s eligibility for
                      CREDIT or INSURANCE, EMPLOYMENT purposes, or for any other
                      purpose(s) authorized under section 604 of the Federal
                      Fair Credit Reporting Act (15 U.S.C. Sec. 1681 et seq.)
                      (‘FCRA’) Driver Privacy Protection Act (‘DPPA’) and
                      Gramm–Leach–Bliley Act (‘GLBA’). {settings.appName} is not
                      a consumer reporting agency and {settings.appName} reports
                      do not constitute consumer reports as such terms are
                      defined in the FCRA, DPPA and GLBA and accordingly these
                      reports may not be used for purposes provided for in the
                      FCRA. As this information is compiled from individual
                      sources, {settings.appName} does not guarantee the
                      comprehensiveness or accuracy of these records, nor that
                      they are a complete history of activity.
                    </span>
                  </Table.Cell>
                </Table.Row>
                {this.state.rows}
              </Table.Body>
            </Table>
          )}
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default MotorVehicles;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/MotorVehicles.js